
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.958 0c1.68 0 3.107.59 4.28 1.77S22 4.378 22 6.054c0 2.27-.768 4.171-2.303 5.703-.47.468-1.251 1.123-2.345 1.964l-.527.4c-1.258.95-2.304 1.715-3.138 2.293l-2.037 1.397c-.18.126-.397.189-.65.189-.235 0-.443-.063-.623-.19l-1.135-.774-1.137-.794c-.776-.55-1.744-1.257-2.903-2.12l-.534-.402c-1.107-.84-1.895-1.495-2.365-1.963C.768 10.225 0 8.324 0 6.054 0 4.378.592 2.95 1.775 1.77S4.389 0 6.069 0C8.129 0 9.772.847 11 2.54c.56-.792 1.278-1.414 2.154-1.864S14.964 0 15.958 0zm.141 2c-1.096 0-2.025.39-2.786 1.169S12.17 4.899 12.17 6.02c0 .324-.116.6-.348.827s-.506.342-.822.342-.585-.114-.808-.342a1.14 1.14 0 01-.334-.827c0-1.121-.39-2.072-1.17-2.85C7.925 2.39 7.005 2 5.927 2s-2 .39-2.772 1.169S2 4.899 2 6.02c0 1.73.567 3.175 1.7 4.334C4.87 11.552 7.303 13.434 11 16l1.507-1.058c2.86-2.032 4.79-3.561 5.793-4.588C19.433 9.194 20 7.75 20 6.02c0-1.121-.38-2.072-1.142-2.85S17.177 2 16.099 2z"}})])
          )
        }
      }
    